export const GretaAIChatFeedback = {
  Down: 'down',
  Up: 'up',
}

export const GretaAIChatMessageRole = {
  Assistant: 'assistant',
  User: 'user',
}

export const GretaAIChatMode = {
  Compact: 'compact',
  Expanded: 'expanded',
}

export const GretaAIChatPanelView = {
  Chat: 'chat',
  Projects: 'projects',
}

export const GretaAIChatProjectSubjectType = {
  Building: 'building',
  Requests: 'requests',
}

export const GRETA_PROJECTS_VISIBLE_LIMIT = 5

export const GRETA_PROJECT_CHATS_VISIBLE_LIMIT = 10

export const GRETA_PROJECT_NAME_MAX_LENGTH = 80

export const GRETA_AI_CHAT_PROJECT_META_SEPARATOR = ' · '

export const GretaAIChatPanelPrefKey = {
  activeChatId: 'activeChatId',
  chatListWidth: 'chatListWidth',
}

export const GretaAIChatRowStatus = {
  Generating: 'generating',
  NewReply: 'newReply',
}

export const GretaAIChatChatActionType = {
  Delete: 'delete',
  Rename: 'rename',
}

export const GRETA_CHAT_TITLE_MAX_LENGTH = 100

// Stopgap row label until the backend replaces it with its own title, so kept short.
export const GRETA_DRAFT_CHAT_TITLE_MAX_LENGTH = 48

export const GRETA_CLIPBOARD_IGNORE_ATTRIBUTE = 'data-clipboard-ignore'

export const GRETA_COPY_FEEDBACK_TIMEOUT_MS = 2000

// Corner neighbours step aside off these (see index.css + MinimizedModalsTray).
export const GRETA_PANEL_VISIBLE_ATTRIBUTE = 'data-greta-panel-visible'

export const GRETA_PANEL_COMPACT_ATTRIBUTE = 'data-greta-panel-compact'

export const GRETA_SILENT_FOCUS_ATTRIBUTE = 'data-greta-silent-focus'

// Shared with CSS: the JS timer that disarms .modeTransition must match the CSS
// transition duration, so it lives here and is injected as a custom property.
export const GRETA_PANEL_ANIM_DURATION_MS = 220

export const GRETA_PANEL_STYLE_VARS = {
  '--greta-panel-anim-duration': `${GRETA_PANEL_ANIM_DURATION_MS}ms`,
}

export const GRETA_PANEL_CHATLIST_DOCK_MIN_WIDTH = 900

export const GRETA_PANEL_CHATLIST_WIDTH = 340

export const GRETA_PANEL_CHATLIST_MIN_WIDTH = 240

export const GRETA_PANEL_CHATLIST_MAX_WIDTH_RATIO = 0.5

export const GRETA_CHAT_LIST_HOVER_CLOSE_DELAY = 120

export const GRETA_PANEL_CHATLIST_FLYOUT_WIDTH = 320

export const GRETA_AI_CHAT_CHAT_LIST_DRAWER_ID = 'gretaAIChatChatListDrawer'

export const QA_NAME_GRETA_AI_CHAT_MODE_TOGGLE = 'gretaAIChatModeToggle'

export const QA_NAME_GRETA_AI_CHAT_CHAT_LIST_TOGGLE =
  'gretaAIChatChatListToggle'

export const QA_NAME_GRETA_AI_CHAT_CHAT_LIST_RESIZE =
  'gretaAIChatChatListResize'

export const QA_NAME_GRETA_AI_CHAT_MINIMIZE = 'gretaAIChatMinimize'

export const QA_NAME_GRETA_AI_CHAT_NEW_CHAT = 'gretaAIChatNewChat'

export const QA_NAME_GRETA_AI_CHAT_CHAT_MENU = 'gretaAIChatChatMenu'

export const QA_NAME_GRETA_AI_CHAT_CHAT_MENU_RENAME =
  'gretaAIChatChatMenuRename'

export const QA_NAME_GRETA_AI_CHAT_CHAT_MENU_COPY_ID =
  'gretaAIChatChatMenuCopyId'

export const QA_NAME_GRETA_AI_CHAT_CHAT_MENU_DELETE =
  'gretaAIChatChatMenuDelete'

export const QA_NAME_GRETA_AI_CHAT_RENAME_INPUT = 'gretaAIChatRenameInput'

export const QA_NAME_GRETA_AI_CHAT_NEW_PROJECT = 'gretaAIChatNewProject'

export const QA_NAME_GRETA_AI_CHAT_PROJECT_RENAME_INPUT =
  'gretaAIChatProjectRenameInput'

export const QA_NAME_GRETA_AI_CHAT_PROJECTS_RETRY = 'gretaAIChatProjectsRetry'

export const GretaAIChatStatus = {
  EmptyReply: 'emptyReply',
  Error: 'error',
  Failed: 'failed',
  Idle: 'idle',
  Loading: 'loading',
  Offline: 'offline',
  SessionExpired: 'sessionExpired',
  SourceRevoked: 'sourceRevoked',
  SourceUnavailable: 'sourceUnavailable',
  Thinking: 'thinking',
  Timeout: 'timeout',
  Unavailable: 'unavailable',
}

export const GRETA_AI_CHAT_NO_ANSWER_TEXT_KEY = 'Greta.StatusNoAnswerKey'

export const GRETA_AI_CHAT_ERROR_TEXT_KEY = {
  [GretaAIChatStatus.EmptyReply]: 'Greta.StatusEmptyReplyKey',
  [GretaAIChatStatus.Error]: 'Greta.StatusErrorKey',
  [GretaAIChatStatus.Failed]: 'Greta.StatusGenerationFailedKey',
  [GretaAIChatStatus.Offline]: 'Greta.StatusOfflineKey',
  [GretaAIChatStatus.SessionExpired]: 'Greta.StatusSessionExpiredKey',
  [GretaAIChatStatus.SourceRevoked]: GRETA_AI_CHAT_NO_ANSWER_TEXT_KEY,
  [GretaAIChatStatus.SourceUnavailable]: GRETA_AI_CHAT_NO_ANSWER_TEXT_KEY,
  [GretaAIChatStatus.Timeout]: 'Greta.StatusTimeoutKey',
  [GretaAIChatStatus.Unavailable]: 'Greta.StatusUnavailableKey',
}

export const GRETA_AI_CHAT_RETRYABLE_STATUSES = [
  GretaAIChatStatus.EmptyReply,
  GretaAIChatStatus.Error,
  GretaAIChatStatus.Failed,
  GretaAIChatStatus.Offline,
  GretaAIChatStatus.SourceRevoked,
  GretaAIChatStatus.SourceUnavailable,
  GretaAIChatStatus.Timeout,
  GretaAIChatStatus.Unavailable,
]

export const GRETA_AI_CHAT_CRITICAL_STATUSES = [
  GretaAIChatStatus.Error,
  GretaAIChatStatus.Failed,
  GretaAIChatStatus.SessionExpired,
  GretaAIChatStatus.Unavailable,
]

// Backend confirms within ~10s (IU-617); poll in that band while running elsewhere.
export const GRETA_AI_CHAT_STATUS_POLL_MS = 2500

// Covers the DB read-replica lag after a turn settles.
export const GRETA_AI_CHAT_SETTLED_GENERATION_GRACE_MS = 5000

export const GRETA_AI_CHAT_BALANCE_NOT_FOUND_ERROR =
  'ai_token_balance_not_found'

export const GRETA_OFFLINE_RECHECK_DELAY_MS = 500

export const GRETA_FEED_SKELETON_TURN_COUNT = 2

export const GRETA_SKELETON_DELAY_MS = 200

export const GRETA_THINKING_TICK_MS = 250

export const GRETA_THINKING_STAGES = [
  { afterMs: 0, textKey: 'Greta.StatusThinkingKey' },
  { afterMs: 6000, textKey: 'Greta.StatusThinkingWorkingKey' },
  { afterMs: 20000, textKey: 'Greta.StatusThinkingLongKey' },
  { afterMs: 60000, textKey: 'Greta.StatusThinkingStopHintKey' },
]

export const GRETA_AI_CHAT_SUGGESTED_PROMPTS = [
  { id: 'default-my-requests', textKey: 'Greta.PromptMyOpenRequestsKey' },
  { id: 'default-today-first', textKey: 'Greta.PromptTodayFirstKey' },
  { id: 'default-top-building', textKey: 'Greta.PromptTopBuildingKey' },
  {
    id: 'default-at-address',
    isTemplate: true,
    textKey: 'Greta.PromptRequestsAtAddressKey',
  },
  // Hidden until the model can draft service request replies.
  {
    id: 'default-draft-reply',
    isHidden: true,
    isTemplate: true,
    textKey: 'Greta.PromptDraftRequestReplyKey',
  },
  { id: 'default-capabilities', textKey: 'Greta.CapabilitiesQuestionKey' },
]

export const GretaAIChatSource = {
  Crm: 'crm',
  Finance: 'finance',
}

export const GretaAIChatFinanceAccess = {
  Available: 'available',
  NoAccess: 'no_access',
  NotBought: 'not_bought',
}

export const GRETA_AI_CHAT_SOURCES = [
  GretaAIChatSource.Crm,
  GretaAIChatSource.Finance,
]

export const GRETA_AI_CHAT_SOURCE_TEXT_KEYS = {
  [GretaAIChatSource.Crm]: {
    askElsewhereKey: 'Greta.AskInCrmChatKey',
    descriptionKey: 'Greta.SourceCrmDescriptionKey',
    nameKey: 'Greta.SourceCrmNameKey',
    pinnedKey: 'Greta.SourceSwitchPinnedCrmKey',
    placeholderKey: 'Greta.ComposerCrmPlaceholderKey',
    shortKey: 'Greta.SourceCrmKey',
  },
  [GretaAIChatSource.Finance]: {
    askElsewhereKey: 'Greta.AskInFinanceChatKey',
    descriptionKey: 'Greta.SourceFinanceDescriptionKey',
    nameKey: 'Greta.SourceFinanceNameKey',
    pinnedKey: 'Greta.SourceSwitchPinnedFinanceKey',
    placeholderKey: 'Greta.ComposerFinancePlaceholderKey',
    shortKey: 'Greta.SourceFinanceKey',
  },
}

export const GRETA_AI_CHAT_SOURCE_SUGGESTED_PROMPTS = {
  [GretaAIChatSource.Crm]: [
    { id: 'default-my-requests', textKey: 'Greta.PromptMyOpenRequestsKey' },
    { id: 'default-today-first', textKey: 'Greta.PromptTodayFirstKey' },
    { id: 'default-top-building', textKey: 'Greta.PromptTopBuildingKey' },
    { id: 'default-capabilities', textKey: 'Greta.CapabilitiesQuestionKey' },
  ],
  [GretaAIChatSource.Finance]: [
    {
      id: 'finance-paid',
      isTemplate: true,
      textKey: 'Greta.PromptFinancePaidKey',
    },
    { id: 'finance-approval', textKey: 'Greta.PromptFinanceApprovalKey' },
    { id: 'finance-due', textKey: 'Greta.PromptFinanceDueKey' },
    { id: 'default-capabilities', textKey: 'Greta.CapabilitiesQuestionKey' },
  ],
}

export const GRETA_AI_CHAT_EMPTY_STATE_SUBTITLE_KEY =
  'Greta.EmptyStateSubtitleKey'

export const GRETA_AI_CHAT_COMPOSER_PLACEHOLDER_KEY =
  'Greta.ComposerPlaceholderKey'

export const GRETA_AI_CHAT_FINANCE_NOT_BOUGHT_TEXT_KEY =
  'Greta.FinanceNotBoughtComposerPlaceholderKey'

export const QA_NAME_GRETA_AI_CHAT_ASK_ELSEWHERE = 'gretaAIChatAskElsewhere'

export const QA_NAME_GRETA_AI_CHAT_FINANCE_PREVIEW = 'gretaAIChatFinancePreview'

export const QA_NAME_GRETA_AI_CHAT_SOURCE_OUTAGE = 'gretaAIChatSourceOutage'

export const QA_NAME_GRETA_AI_CHAT_SOURCE_REVOKED = 'gretaAIChatSourceRevoked'

export const QA_NAME_GRETA_AI_CHAT_SOURCE_PICKER = 'gretaAIChatSourcePicker'

export const QA_NAME_GRETA_AI_CHAT_SOURCE_SWITCH = 'gretaAIChatSourceSwitch'

export const QA_NAME_GRETA_AI_CHAT_EMPTY_CHAT = 'gretaAIChatEmptyChat'

export const QA_NAME_GRETA_AI_CHAT_EMPTY_STATE = 'gretaAIChatEmptyState'

export const QA_NAME_GRETA_AI_CHAT_LIMIT_NOTICE = 'gretaAIChatLimitNotice'

export const QA_NAME_GRETA_AI_CHAT_LOCKED_STATE = 'gretaAIChatLockedState'

export const QA_NAME_GRETA_AI_CHAT_LOCKED_SUPPORT = 'gretaAIChatLockedSupport'

export const QA_NAME_GRETA_AI_CHAT_MESSAGE_LIST_SKELETON =
  'gretaAIChatMessageListSkeleton'

export const QA_NAME_GRETA_AI_CHAT_SUGGESTED_PROMPT =
  'gretaAIChatSuggestedPrompt'
